import { useNavigate } from "react-router-dom";
import Header from "../../commonComponents/header/Header";
import Footer from "../../commonComponents/footer/Footer";

const InterviewNotYetOpen = () => {
  const navigate = useNavigate();

  // Message is stored by verifyOTP() after a successful OTP verification
  const message =
    sessionStorage.getItem("accessMessage") ||
    "Your assessment slot has not opened yet. Please check back closer to your scheduled time.";

  const handleBack = () => {
    navigate("/screenup-login");
  };

  return (
    <div className="flex flex-col min-h-screen bg-white pt-4 px-4 font-sans">
      <Header />

      <div className="flex-1 flex justify-center items-center px-6">
        <div className="w-full max-w-md text-center">
          {/* Status badge */}
          <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 text-sm font-medium px-3 py-1 rounded-full mb-6">
            <span className="w-2 h-2 rounded-full bg-amber-400 inline-block" />
            Not Open Yet
          </div>

          <h2 className="app-title font-[500] mb-4 text-fontColor">
            Assessment Not Yet Available
          </h2>

          <p className="app-body text-fontColor leading-relaxed">{message}</p>

          <p className="app-note text-fontColor mt-4 opacity-70">
            Please return at your scheduled assessment time. If you believe this
            is an error, contact the hiring team for assistance.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default InterviewNotYetOpen;
